<div class="simulation-container" role="region" aria-label="Simulation de conversation">
  <!-- Messages area with scrolling -->
  <div class="simulation-messages-container" #scrollContainer role="log" aria-live="polite" aria-relevant="additions">
    <div class="simulation-messages">
      @for (message of messages; track trackByFn($index, message)) {
        <div class="simulation-message" [class.user-message]="message.isUser" [class.bot-message]="!message.isUser" [class.error-message]="message.isError">
          <div class="avatar">
            @if (message.isUser) {
              <ng-lottie class="avatar" width="32px" [options]="avatarAnimationOptions" [style.background-color]="getBackgroundColorForAvatar()" (error)="onError($event)" />
            } @else {
              <img width="32px" src="/assets/dici.png" draggable="false" alt="Avatar" />
            }
          </div>
          <div class="message-content">
            <div class="message-text" [innerHTML]="message.content | markdown"></div>
            <div class="message-timestamp">
              {{ message.timestamp | date: 'shortTime' }}
            </div>
            <!-- Retry button for error messages -->
            @if (message.isError && message.error?.retryable) {
              <div class="error-actions">
                <button class="retry-button" (click)="retryLastMessage()">
                  <i class="bi bi-arrow-repeat"></i>
                  {{ 'moduleCompletion.retry' | translate }}
                </button>
              </div>
            }
          </div>
        </div>
      }

      <!-- Loading indicator -->
      @if (isLoading) {
        <div class="typing-indicator">
          <div class="typing-avatar">
            <img width="24px" src="/assets/dici.png" draggable="false" alt="Dici Avatar" />
          </div>
          <div class="typing-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
          @if (showProgressBar) {
            <div class="typing-progress">
              <div class="progress">
                <div class="progress-bar" [style.width.%]="loadingProgress"></div>
              </div>
            </div>
          }
        </div>
      }

      <!-- Completion indicator -->
      @if (isComplete) {
        <div class="simulation-complete">
          <div class="complete-indicator">
            <i class="bi bi-check-circle-fill"></i>
            <span>{{ 'questions.simulation.over' | translate }}</span>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Input area -->
  <div class="simulation-input-container" [class.loading]="isLoading" [class.disabled]="isComplete" (click)="focusInputField()">
    <div class="input-wrapper" [class.loading]="isLoading">
      <input
        type="text"
        class="simulation-input"
        [placeholder]="getInputPlaceholder()"
        [(ngModel)]="inputMessage"
        [disabled]="isLoading || isComplete"
        [readonly]="isLoading"
        [attr.aria-disabled]="isLoading || isComplete"
        #messageInput
      />
      @if (isLoading) {
        <div class="input-loading-indicator">
          <span>{{ loadingMessage }}</span>
          <div class="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      }
    </div>
    <div
      (click)="sendMessage()"
      (keydown.enter)="sendMessage()"
      (keydown.space)="sendMessage()"
      class="simulation-send-button"
      [class.disabled]="isLoading || !inputMessage.trim() || isComplete"
      [class.loading]="isLoading"
      [attr.aria-label]="isLoading ? 'Envoi en cours' : 'Envoyer le message'"
      [attr.aria-disabled]="isLoading || !inputMessage.trim() || isComplete"
      [attr.tabindex]="isLoading || !inputMessage.trim() || isComplete ? -1 : 0"
      role="button"
    >
      @if (!isLoading && !isComplete) {
        <i class="bi bi-send-fill"></i>
      }
      @if (isComplete) {
        <i class="bi bi-check-circle-fill"></i>
      }
      @if (isLoading) {
        <div class="loading-spinner">
          <i class="bi bi-arrow-repeat"></i>
        </div>
      }
    </div>
  </div>
</div>
